"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CollapsibleLink = _interopRequireDefault(require("../general/CollapsibleLink"));

/**
* @class CollapsibleDivider
* @desc A specially-styled CollapsibleLink within a divider
*
* @param {string} [data-id=collapsible-divider]
*     The data-id of the component
* @param {string} [className]
*     Class name(s) to add to the top-level container/div
* @param {string} [title]
*     The text within the divider
* @param {boolean} [open=false]
*     Whether it's open or not
* @param {function} onToggle
*     Handler for toggling the link
*/
var CollapsibleDivider = function CollapsibleDivider(_ref) {
  var title = _ref.title,
      open = _ref.open,
      onToggle = _ref.onToggle,
      className = _ref.className,
      dataId = _ref["data-id"];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("collapsible-divider", className),
    "data-id": dataId
  }, /*#__PURE__*/_react.default.createElement(_CollapsibleLink.default, {
    title: title,
    className: "collapsible-divider__toggle",
    expanded: open,
    onToggle: onToggle
  }));
};

CollapsibleDivider.propTypes = {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  title: _propTypes.default.string,
  open: _propTypes.default.bool,
  onToggle: _propTypes.default.func
};
CollapsibleDivider.defaultProps = {
  "data-id": "collapsible-divider",
  open: false
};
var _default = CollapsibleDivider;
exports.default = _default;
module.exports = exports["default"];